import { useEffect, useState } from 'react';
import { Box, Button, Pagination, Stack, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Header from 'components/Header/Header';
import AddIcon from '@mui/icons-material/Add';
import { IHeader } from 'components/Header';
import { searchMasterList, deleteMasterById } from 'actions/LaboratoryActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IReducer } from 'Reducers/IReducer';
import { MasterTable } from './MasterTable/MasterTable';
import { IMasterProps } from 'pages/Master';
import { DeleteDialog } from 'components/DeleteDialog';
import { IMaster } from 'exactt-types/lib';

function _Master(props: IMasterProps) {
  const navigate = useNavigate();

  const [deleteMaster, setdeleteMaster] = useState<IMaster | undefined>(undefined);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  // pagination
  const [page, setPage] = useState(1);
  const size = 15;

  const laboratoryId = props.laboratory?.details._id || '';

  const onFocus = async () => {
    await props.searchMasterList(laboratoryId, { page: page, size: size, query: searchQuery });
  };

  const handleDeleteMaster = async () => {
    try {
      setDeleteLoading(true);
      await props.deleteMasterById(laboratoryId, deleteMaster?._id || '', {
        page: 1,
        size: size,
        query: searchQuery,
      });
    } catch (err) {
      console.log(err);
    } finally {
      props.searchMasterList(laboratoryId, { page: page, size: size, query: searchQuery });
      setDeleteModal(false);
      setDeleteLoading(false);
    }
  };

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
    props.searchMasterList(props.laboratory?.details?._id || '', { page: value, size: size, query: searchQuery });
  };

  useEffect(() => {
    onFocus();
    props.searchMasterList(laboratoryId, { page: page, size: size, query: searchQuery });
    // eslint-disable-next-line
  }, [searchQuery]);

  const breadcrumbsList: IHeader['breadcrumbsList'] = [
    {
      label: 'Dashboard',
      onClick: () => navigate('/'),
    },
    {
      label: 'Masters',
      onClick: () => navigate('/laboratory/Masters'),
    },
  ];

  return (
    <Box>
      <Header
        breadcrumbsList={breadcrumbsList}
        title="Masters"
        right={
          <Box display={'flex'} alignItems={'center'} gap={2}>
            <TextField
              label={'Search'}
              size={'small'}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Button
              variant={'contained'}
              startIcon={<AddIcon />}
              onClick={() => navigate('/laboratory/masters/persist')}
            >
              Create Master
            </Button>
          </Box>
        }
      />
      <Box p={2} pt={10}>
        <MasterTable
          data={props.masters}
          onCopy={(master) => navigate(`/laboratory/masters/persist?copyFrom=${master._id}`)}
          onDelete={(master) => {
            setdeleteMaster(master);
            setDeleteModal(true);
          }}
          onEdit={(master) => navigate(`/laboratory/masters/persist?id=${master._id}`)}
        />
      </Box>
      <DeleteDialog
        title="Remove user"
        message={`Are you sure you want to remove ${deleteMaster?.sampleName} Master?`}
        isVisible={deleteModal}
        onClose={() => setDeleteModal(false)}
        onAction={() => handleDeleteMaster()}
        isLoading={deleteLoading}
      />
      <Stack spacing={2}>
        <Pagination count={props.count} shape="rounded" page={page} onChange={handlePageChange} defaultPage={page} />
      </Stack>
    </Box>
  );
}

const mapStateToProps = (state: IReducer) => {
  return {
    laboratory: state.laboratory.current,
    masters: state.laboratory.masters,
    count: state.laboratory.count.master,
  };
};

function mapDispatchToProps(dispatch: any) {
  return {
    ...bindActionCreators({ searchMasterList, deleteMasterById }, dispatch),
  };
}

export const Master = connect(mapStateToProps, mapDispatchToProps)(_Master);
